import { render } from "./WalletActity.vue?vue&type=template&id=8762bbfe&scoped=true"
import script from "./WalletActity.vue?vue&type=script&lang=js"
export * from "./WalletActity.vue?vue&type=script&lang=js"

import "./WalletActity.vue?vue&type=style&index=0&id=8762bbfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8762bbfe"]])

export default __exports__